interface IProps {
  strokeColor?: string;
  className?: string;
  width?: string;
  height?: string;
}

export const HomeIcon = ({ strokeColor }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.86823 14.4V9.53091C5.86823 9.08272 6.25028 8.71939 6.72156 8.71939H9.28156C9.75285 8.71939 10.1349 9.08272 10.1349 9.53091V14.4M7.50704 1.75017L1.96037 5.50118C1.73526 5.65341 1.60156 5.89985 1.60156 6.16253V13.1827C1.60156 13.855 2.17464 14.4 2.88156 14.4H13.1216C13.8285 14.4 14.4016 13.855 14.4016 13.1827V6.16253C14.4016 5.89985 14.2679 5.65341 14.0428 5.50118L8.49609 1.75017C8.20002 1.54995 7.80311 1.54995 7.50704 1.75017Z"
        stroke={strokeColor ?? 'white'}
        strokeLinecap="round"
      />
    </svg>
  );
};
export const VisitsIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2222 7.20001L12 9.20001M12 9.20001L10.2222 11.2M12 9.20001H4.79998M4.79998 4.4004H11.4666M14.4 4.00001V12C14.4 13.3255 13.3255 14.4 12 14.4H3.99998C2.67449 14.4 1.59998 13.3255 1.59998 12V4.00001C1.59998 2.67452 2.67449 1.60001 3.99998 1.60001H12C13.3255 1.60001 14.4 2.67452 14.4 4.00001Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HolidayMasterIcon = ({ strokeColor }: IProps) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.58398 5.64587H12.084M2.94113 1.33337V2.45851M10.584 1.33337V2.45837M10.584 2.45837H3.08398C1.84134 2.45837 0.833984 3.46573 0.833984 4.70837V12.2084C0.833984 13.4511 1.84134 14.4584 3.08398 14.4584H10.584C11.8266 14.4584 12.834 13.4511 12.834 12.2084L12.834 4.70837C12.834 3.46573 11.8266 2.45837 10.584 2.45837ZM3.45898 8.27091H10.209M3.45898 11.2709H10.209"
        stroke={strokeColor ?? 'white'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DepositBankIcon = ({ strokeColor }: IProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66628 8.99997V7.22087M5.22183 8.99997V7.22087M8.77739 8.99997V7.22087M12.3329 8.99997V7.22087M0.599609 11.2666H13.3996V13.4H0.599609V11.2666ZM0.599609 4.86664V3.44442L6.73659 0.599976L13.3996 3.44442V4.86664H0.599609Z"
        stroke={strokeColor ?? 'white'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ strokeColor = '#1047DC' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00742 2.08081H3.00742C1.68194 2.08081 0.607422 3.15532 0.607422 4.48081V12.4809C0.607422 13.8064 1.68194 14.8809 3.00742 14.8809H11.0074C12.3329 14.8809 13.4074 13.8064 13.4074 12.4809L13.4074 8.48084M4.60742 10.8808L7.51808 10.2943C7.6726 10.2632 7.81447 10.1871 7.9259 10.0756L14.4417 3.55626C14.7541 3.24369 14.7539 2.73703 14.4412 2.42472L13.0609 1.04601C12.7484 0.733828 12.242 0.734041 11.9297 1.04648L5.41326 7.56652C5.30205 7.67779 5.22612 7.81938 5.19496 7.97357L4.60742 10.8808Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashIcon = ({ strokeColor = '#BA1C1C' }: IProps) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.24219 4.44688H15.0422M6.24219 2.04688H11.0422M7.04219 12.4469V7.64688M10.2422 12.4469V7.64688M11.4422 15.6469H5.84219C4.95853 15.6469 4.24219 14.9305 4.24219 14.0469L3.87691 5.28018C3.85797 4.82568 4.22132 4.44688 4.67621 4.44688H12.6082C13.0631 4.44688 13.4264 4.82568 13.4075 5.28018L13.0422 14.0469C13.0422 14.9305 12.3258 15.6469 11.4422 15.6469Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InfoIcon = () => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.032 14.0454C15.5727 14.0454 16.5348 12.3767 15.7629 11.0434L10.2317 1.48963C9.46142 0.159057 7.54037 0.159057 6.77004 1.48963L1.23894 11.0434C0.467007 12.3767 1.42912 14.0454 2.96979 14.0454H14.032ZM7.68271 11.5909V9.95452H9.31908V11.5909H7.68271ZM7.68271 8.31815V5.04543H9.31908V8.31815H7.68271Z"
        fill="#BA1C1C"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16732 8.66648H6.83398C7.20065 8.66648 7.50065 8.36648 7.50065 7.99982V4.66648H8.56065C9.15399 4.66648 9.45398 3.94648 9.03398 3.52648L5.97398 0.466484C5.71398 0.206484 5.29398 0.206484 5.03398 0.466484L1.97398 3.52648C1.55398 3.94648 1.84732 4.66648 2.44065 4.66648H3.50065V7.99982C3.50065 8.36648 3.80065 8.66648 4.16732 8.66648ZM1.50065 9.99982H9.50065C9.86732 9.99982 10.1673 10.2998 10.1673 10.6665C10.1673 11.0332 9.86732 11.3332 9.50065 11.3332H1.50065C1.13398 11.3332 0.833984 11.0332 0.833984 10.6665C0.833984 10.2998 1.13398 9.99982 1.50065 9.99982Z"
        fill="#1047DC"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00586 4.38462H14.8059M6.00586 1.98462H10.8059M6.80586 12.3846V7.58462M10.0059 12.3846V7.58462M11.2059 15.5846H5.60586C4.7222 15.5846 4.00586 14.8683 4.00586 13.9846L3.64058 5.21792C3.62164 4.76342 3.98499 4.38462 4.43989 4.38462H12.3718C12.8267 4.38462 13.1901 4.76342 13.1711 5.21792L12.8059 13.9846C12.8059 14.8683 12.0895 15.5846 11.2059 15.5846Z"
        stroke="#A91919"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileUploadIcon = ({ strokeColor = '#1047DC' }: IProps) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60664 15.1847H4.40663C3.52298 15.1847 2.80663 14.4684 2.80664 13.5847L2.8067 3.98476C2.80671 3.1011 3.52305 2.38477 4.4067 2.38477H11.6069C12.4905 2.38477 13.2069 3.10111 13.2069 3.98477V8.38476M10.8069 12.8131L12.4431 11.1848M12.4431 11.1848L14.0069 12.7395M12.4431 11.1848V15.1848M5.60689 5.58476H10.4069M5.60689 7.98476H10.4069M5.60689 10.3848H8.00689"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AttachmentIcon = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8588 6.88447L7.05069 12.2094C6.47895 12.8426 5.55198 12.8425 4.98024 12.2094C4.4073 11.5748 4.40868 10.5456 4.98331 9.91299L8.71188 5.80807L9.64824 4.77106C10.7875 3.50931 12.6347 3.50931 13.774 4.77107C14.9133 6.03282 14.9133 8.07852 13.774 9.34028L12.8517 10.3617L9.35629 14.2328C7.54818 16.3187 4.80842 16.6361 2.89285 14.5995C1.00073 12.5878 1.32144 9.57189 3.23456 7.45315L6.71625 3.59668"
        stroke="#1047DC"
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDown = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0078 7.18452L8.80781 10.3845L5.60781 7.18452"
        stroke="#999DA8"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationsIdle = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.3787 18.5837H21.2376C21.7061 18.5837 21.9717 17.8755 21.6958 17.4697C21.0571 16.53 20.4367 15.1449 20.4367 13.4745L20.4642 11.1898C20.4642 6.65779 17.0362 2.98389 12.8076 2.98389C8.6404 2.98389 5.2622 6.60446 5.2622 11.0707L5.23474 13.4745C5.23474 15.1335 4.59215 16.5111 3.92639 17.4504C3.63947 17.8552 3.90439 18.5837 4.3787 18.5837Z"
        fill="#1B1D22"
      />
      <path
        d="M3.92639 17.4504L3.51846 17.1612H3.51846L3.92639 17.4504ZM5.23474 13.4745L4.73474 13.4688V13.4745H5.23474ZM5.2622 11.0707L5.7622 11.0764V11.0707H5.2622ZM21.6958 17.4697L22.1094 17.1886V17.1886L21.6958 17.4697ZM20.4367 13.4745L19.9367 13.4685V13.4745H20.4367ZM20.4642 11.1898L20.9642 11.1958V11.1898H20.4642ZM9.80762 21.6837C9.53148 21.6837 9.30762 21.9076 9.30762 22.1837C9.30762 22.4599 9.53148 22.6837 9.80762 22.6837V21.6837ZM15.8076 22.6837C16.0838 22.6837 16.3076 22.4599 16.3076 22.1837C16.3076 21.9076 16.0838 21.6837 15.8076 21.6837V22.6837ZM4.33431 17.7395C5.04225 16.7407 5.73474 15.264 5.73474 13.4745H4.73474C4.73474 15.0029 4.14205 16.2815 3.51846 17.1612L4.33431 17.7395ZM5.73471 13.4802L5.76217 11.0764L4.76223 11.0649L4.73477 13.4688L5.73471 13.4802ZM22.1094 17.1886C21.5114 16.3088 20.9367 15.02 20.9367 13.4745H19.9367C19.9367 15.2697 20.6029 16.7512 21.2823 17.7507L22.1094 17.1886ZM20.9367 13.4805L20.9641 11.1958L19.9642 11.1838L19.9368 13.4685L20.9367 13.4805ZM20.9642 11.1898C20.9642 6.41484 17.3444 2.48389 12.8076 2.48389V3.48389C16.728 3.48389 19.9642 6.90074 19.9642 11.1898H20.9642ZM21.2376 19.0837C21.7533 19.0837 22.0773 18.6988 22.2105 18.3634C22.3457 18.0231 22.3631 17.5619 22.1094 17.1886L21.2823 17.7507C21.2919 17.7648 21.3046 17.7935 21.3072 17.8415C21.3098 17.8899 21.3009 17.9446 21.2811 17.9943C21.261 18.0449 21.2367 18.0732 21.2237 18.0841C21.2145 18.0919 21.2211 18.0837 21.2376 18.0837V19.0837ZM5.7622 11.0707C5.7622 6.8474 8.94861 3.48389 12.8076 3.48389V2.48389C8.33219 2.48389 4.7622 6.36151 4.7622 11.0707H5.7622ZM4.3787 18.0837C4.39613 18.0837 4.40292 18.0925 4.39301 18.084C4.37927 18.0722 4.35409 18.0421 4.33367 17.9891C4.31363 17.9371 4.30506 17.8803 4.30828 17.8305C4.31147 17.7812 4.32494 17.7527 4.33431 17.7395L3.51846 17.1612C3.25347 17.5351 3.26784 18.0042 3.40051 18.3486C3.53098 18.6873 3.85504 19.0837 4.3787 19.0837V18.0837ZM21.2376 18.0837H4.3787V19.0837H21.2376V18.0837ZM9.80762 22.6837H15.8076V21.6837H9.80762V22.6837Z"
        fill="#1B1D22"
      />
    </svg>
  );
};

type Props = {
  strokeColor?: string;
};
export const RupeeIcon = ({
  width = '17',
  height = '17',
  strokeColor = '#1B1D22',
}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M12.5709 3.48584H5.23755H7.23755C7.94479 3.48584 8.62307 3.76679 9.12317 4.26689C9.62326 4.76699 9.90422 5.44526 9.90422 6.15251C9.90422 6.85975 9.62326 7.53803 9.12317 8.03812C8.62307 8.53822 7.94479 8.81917 7.23755 8.81917H5.23755L9.23755 12.8192M5.23755 6.15251H12.5709"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrossIcon = ({ strokeColor = '#BA1C1C' }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6666 3.91699L3.33331 13.2503M12.6666 13.2503L3.33331 3.91699"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ApproveIcon = ({ strokeColor = '#318439' }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4 8.58384C14.4 12.1185 11.5346 14.9838 7.99998 14.9838C4.46535 14.9838 1.59998 12.1185 1.59998 8.58384C1.59998 5.04922 4.46535 2.18384 7.99998 2.18384C9.0041 2.18384 9.95422 2.41508 10.8 2.82722M13.2 4.58384L7.59998 10.1838L5.99998 8.58384"
        stroke={strokeColor}
      />
    </svg>
  );
};

export const PreviewIcon = () => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.24866 6.03485C9.24866 7.00218 8.52098 7.78637 7.62334 7.78637C6.7257 7.78637 5.99802 7.00218 5.99802 6.03485C5.99802 5.06751 6.7257 4.28333 7.62334 4.28333C8.52098 4.28333 9.24866 5.06751 9.24866 6.03485Z"
        stroke="#1047DC"
        strokeWidth="0.9"
      />
    </svg>
  );
};

export const PlusCircleIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <path
          d="M16.159 12.0242H12.559M12.559 12.0242H8.95898M12.559 12.0242V15.6242M12.559 12.0242L12.559 8.42422M22.159 12.0248C22.159 17.3267 17.8609 21.6248 12.559 21.6248C7.25705 21.6248 2.95898 17.3267 2.95898 12.0248C2.95898 6.72287 7.25705 2.4248 12.559 2.4248C17.8609 2.4248 22.159 6.72287 22.159 12.0248Z"
          stroke="#1047DC"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export const MinusCircleIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.95898 12.0248H16.159M22.159 12.0248C22.159 17.3267 17.8609 21.6248 12.559 21.6248C7.25705 21.6248 2.95898 17.3267 2.95898 12.0248C2.95898 6.72287 7.25705 2.4248 12.559 2.4248C17.8609 2.4248 22.159 6.72287 22.159 12.0248Z"
        stroke="#1047DC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AuctionIcon = ({ strokeColor = '#C8A864' }: Props) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90006 1.22497C7.65006 1.49997 7.52506 1.84997 7.62506 1.99997C7.90006 2.42497 4.75006 5.52497 4.22506 5.37497C4.02506 5.29997 3.62506 5.47497 3.37506 5.74997C2.90006 6.27497 2.92506 6.29997 4.57506 7.92497C6.20006 9.57497 6.22506 9.59997 6.72506 9.14997C7.00006 8.89997 7.20006 8.44997 7.17506 8.14997C7.12506 7.72497 7.25006 7.62497 7.87506 7.62497C8.50006 7.62497 9.12506 8.12497 11.5501 10.475C13.6001 12.5 14.5751 13.275 14.8501 13.175C15.8751 12.775 15.5751 12.2 12.7251 9.29997C10.3751 6.87497 9.87506 6.24997 9.87506 5.62497C9.87506 4.99997 9.97506 4.87497 10.4001 4.92497C10.7001 4.94997 11.1501 4.74997 11.4001 4.47497C11.8251 3.99997 11.8001 3.94997 10.2501 2.37497C9.35006 1.47497 8.57506 0.749968 8.47506 0.749968C8.40006 0.749968 8.12506 0.974968 7.90006 1.22497ZM9.87506 2.74997C10.5501 3.42497 11.0251 4.07497 10.9251 4.17497C10.7251 4.34997 8.25006 2.04997 8.25006 1.69997C8.25006 1.27497 8.70006 1.54997 9.87506 2.74997ZM9.12506 3.49997L9.85006 4.27497L8.17506 5.94997L6.50006 7.62497L5.70006 6.79997L4.87506 5.99997L6.50006 4.37497C7.37506 3.47497 8.17506 2.74997 8.25006 2.74997C8.35006 2.74997 8.72506 3.09997 9.12506 3.49997ZM8.87506 6.49997C8.47506 6.89997 8.10006 7.19997 8.05006 7.12497C7.87506 6.94997 9.02506 5.74997 9.35006 5.74997C9.47506 5.74997 9.27506 6.07497 8.87506 6.49997ZM5.37506 7.24997C6.05006 7.92497 6.52506 8.57497 6.42506 8.67497C6.22506 8.84997 3.75006 6.54997 3.75006 6.19997C3.75006 5.77497 4.20006 6.04997 5.37506 7.24997ZM14.9251 12.675C14.6751 12.9 8.97506 7.22497 9.17506 6.92497C9.25006 6.79997 10.6251 7.99997 12.2001 9.57497C13.8001 11.175 15.0251 12.575 14.9251 12.675Z"
        fill={strokeColor}
      />
      <path
        d="M1.575 11.225C1.5 11.5 1.25 11.75 0.975 11.825C0.65 11.9 0.5 12.175 0.5 12.6V13.25H3.75H7V12.6C7 12.175 6.85 11.9 6.525 11.825C6.25 11.75 6 11.5 5.925 11.225C5.8 10.8 5.55 10.75 3.75 10.75C1.95 10.75 1.7 10.8 1.575 11.225ZM5.5 11.5C5.5 11.65 4.75 11.75 3.75 11.75C2.75 11.75 2 11.65 2 11.5C2 11.35 2.75 11.25 3.75 11.25C4.75 11.25 5.5 11.35 5.5 11.5ZM6.5 12.5C6.5 12.65 5.425 12.75 3.75 12.75C2.075 12.75 1 12.65 1 12.5C1 12.35 2.075 12.25 3.75 12.25C5.425 12.25 6.5 12.35 6.5 12.5Z"
        fill={strokeColor}
      />
    </svg>
  );
};
export const TargetsIcon = ({
  width = '16',
  height = '16',
  strokeColor = '#C8A864',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5637 8.39995C14.5637 8.12381 14.3398 7.89995 14.0637 7.89995C13.7875 7.89995 13.5637 8.12381 13.5637 8.39995H14.5637ZM7.66367 2.49995C7.93981 2.49995 8.16367 2.27609 8.16367 1.99995C8.16367 1.72381 7.93981 1.49995 7.66367 1.49995V2.49995ZM11.3637 8.39995C11.3637 8.12381 11.1398 7.89995 10.8637 7.89995C10.5875 7.89995 10.3637 8.12381 10.3637 8.39995H11.3637ZM7.66367 5.69995C7.93981 5.69995 8.16367 5.47609 8.16367 5.19995C8.16367 4.92381 7.93981 4.69995 7.66367 4.69995V5.69995ZM10.8457 5.79608C11.0409 5.60082 11.0409 5.28424 10.8457 5.08898C10.6504 4.89371 10.3338 4.89371 10.1385 5.08898L10.8457 5.79608ZM7.31012 7.9174C7.11486 8.11267 7.11486 8.42925 7.31012 8.62451C7.50538 8.81977 7.82196 8.81977 8.01722 8.62451L7.31012 7.9174ZM14.7361 3.46269L15.0896 3.81625C15.2236 3.68233 15.2703 3.48425 15.2104 3.30458C15.1505 3.12491 14.9943 2.9945 14.8068 2.96772L14.7361 3.46269ZM12.1905 6.00828L12.0324 6.48262C12.2121 6.54251 12.4101 6.49575 12.5441 6.36183L12.1905 6.00828ZM9.92776 3.74554L9.57421 3.39198C9.44029 3.5259 9.39353 3.72398 9.45342 3.90365L9.92776 3.74554ZM12.4733 1.19995L12.9683 1.12924C12.9415 0.941758 12.8111 0.785499 12.6315 0.72561C12.4518 0.66572 12.2537 0.712482 12.1198 0.846398L12.4733 1.19995ZM10.4934 5.44259L10.0191 5.60071C10.0689 5.75001 10.186 5.86717 10.3353 5.91693L10.4934 5.44259ZM12.7562 3.17985L12.2612 3.25056C12.2926 3.47055 12.4655 3.6434 12.6855 3.67483L12.7562 3.17985ZM13.5637 8.39995C13.5637 11.6584 10.9222 14.3 7.66367 14.3V15.3C11.4744 15.3 14.5637 12.2107 14.5637 8.39995H13.5637ZM7.66367 14.3C4.40519 14.3 1.76367 11.6584 1.76367 8.39995H0.763672C0.763672 12.2107 3.85291 15.3 7.66367 15.3V14.3ZM1.76367 8.39995C1.76367 5.14147 4.40519 2.49995 7.66367 2.49995V1.49995C3.85291 1.49995 0.763672 4.58919 0.763672 8.39995H1.76367ZM10.3637 8.39995C10.3637 9.89112 9.15484 11.1 7.66367 11.1V12.1C9.70712 12.1 11.3637 10.4434 11.3637 8.39995H10.3637ZM7.66367 11.1C6.1725 11.1 4.96367 9.89112 4.96367 8.39995H3.96367C3.96367 10.4434 5.62022 12.1 7.66367 12.1V11.1ZM4.96367 8.39995C4.96367 6.90878 6.1725 5.69995 7.66367 5.69995V4.69995C5.62022 4.69995 3.96367 6.3565 3.96367 8.39995H4.96367ZM10.1385 5.08898L7.31012 7.9174L8.01722 8.62451L10.8457 5.79608L10.1385 5.08898ZM14.3825 3.10914L11.837 5.65472L12.5441 6.36183L15.0896 3.81625L14.3825 3.10914ZM10.2813 4.09909L12.8269 1.5535L12.1198 0.846398L9.57421 3.39198L10.2813 4.09909ZM12.3486 5.53394L10.6516 4.96825L10.3353 5.91693L12.0324 6.48262L12.3486 5.53394ZM10.9678 5.28448L10.4021 3.58742L9.45342 3.90365L10.0191 5.60071L10.9678 5.28448ZM11.9784 1.27066L12.2612 3.25056L13.2512 3.10914L12.9683 1.12924L11.9784 1.27066ZM12.6855 3.67483L14.6654 3.95767L14.8068 2.96772L12.8269 2.68488L12.6855 3.67483Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const RefreshIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46249 4.94561C3.57445 3.03264 5.65278 1.74561 8.03317 1.74561C10.7321 1.74561 13.0427 3.40014 13.9967 5.74561M4.41571 5.74561H1.2002V2.54561M13.5379 11.3456C12.4259 13.2586 10.3476 14.5456 7.96722 14.5456C5.2683 14.5456 2.95768 12.8911 2.00366 10.5456M11.5847 10.5456H14.8002V13.7456"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FailureIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.531 20.1909C19.0717 20.1909 20.0338 18.5222 19.2619 17.1889L13.7308 7.63513C12.9604 6.30456 11.0394 6.30456 10.2691 7.63513L4.73796 17.1889C3.96603 18.5222 4.92815 20.1909 6.46881 20.1909H17.531ZM11.1817 17.7364V16.1H12.8181V17.7364H11.1817ZM11.1817 14.4637V11.1909H12.8181V14.4637H11.1817Z"
        fill="#A91919"
      />
      <mask
        id="mask0_546_23433"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="6"
        width="16"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.531 20.1909C19.0717 20.1909 20.0338 18.5222 19.2619 17.1889L13.7308 7.63513C12.9604 6.30456 11.0394 6.30456 10.2691 7.63513L4.73796 17.1889C3.96603 18.5222 4.92815 20.1909 6.46881 20.1909H17.531ZM11.1817 17.7364V16.1H12.8181V17.7364H11.1817ZM11.1817 14.4637V11.1909H12.8181V14.4637H11.1817Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_546_23433)">
        <rect y="0.645508" width="24" height="24" fill="#A91919" />
      </g>
    </svg>
  );
};
export const ClockIcon = ({ strokeColor = '#1047DC' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M13.5841 2.84388C13.3888 2.64862 13.0722 2.64862 12.877 2.84388C12.6817 3.03915 12.6817 3.35573 12.877 3.55099L13.5841 2.84388ZM14.5465 5.22056C14.7418 5.41582 15.0584 5.41582 15.2536 5.22056C15.4489 5.02529 15.4489 4.70871 15.2536 4.51345L14.5465 5.22056ZM8.72184 7.31338C8.72184 7.03724 8.49798 6.81338 8.22184 6.81338C7.94569 6.81338 7.72184 7.03724 7.72184 7.31338H8.72184ZM7.72184 9.72497C7.72184 10.0011 7.94569 10.225 8.22184 10.225C8.49798 10.225 8.72184 10.0011 8.72184 9.72497H7.72184ZM6.36676 1.21338C6.09062 1.21338 5.86676 1.43724 5.86676 1.71338C5.86676 1.98952 6.09062 2.21338 6.36676 2.21338V1.21338ZM9.8914 2.21338C10.1675 2.21338 10.3914 1.98952 10.3914 1.71338C10.3914 1.43724 10.1675 1.21338 9.8914 1.21338V2.21338ZM12.3205 5.06997C12.1252 5.26523 12.1252 5.58182 12.3205 5.77708C12.5157 5.97234 12.8323 5.97234 13.0276 5.77708L12.3205 5.06997ZM14.0653 4.03222L14.4189 3.67867L14.0653 4.03222ZM7.72184 7.31338V9.72497H8.72184V7.31338H7.72184ZM6.36676 2.21338H9.8914V1.21338H6.36676V2.21338ZM13.0276 5.77708L14.4189 4.38577L13.7118 3.67867L12.3205 5.06997L13.0276 5.77708ZM13.8436 9.8757C13.8436 12.9805 11.3266 15.4974 8.22184 15.4974V16.4974C11.8789 16.4974 14.8436 13.5328 14.8436 9.8757H13.8436ZM8.22184 15.4974C5.11704 15.4974 2.6001 12.9805 2.6001 9.8757H1.6001C1.6001 13.5328 4.56475 16.4974 8.22184 16.4974V15.4974ZM2.6001 9.8757C2.6001 6.7709 5.11704 4.25396 8.22184 4.25396V3.25396C4.56475 3.25396 1.6001 6.21861 1.6001 9.8757H2.6001ZM8.22184 4.25396C11.3266 4.25396 13.8436 6.7709 13.8436 9.8757H14.8436C14.8436 6.21861 11.8789 3.25396 8.22184 3.25396V4.25396ZM12.877 3.55099L13.7118 4.38577L14.4189 3.67867L13.5841 2.84388L12.877 3.55099ZM13.7118 4.38577L14.5465 5.22056L15.2536 4.51345L14.4189 3.67867L13.7118 4.38577Z"
        fill={strokeColor}
      />
    </svg>
  );
};
export const MoneyLoanIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        width="16"
        height="16"
        transform="translate(0.5 0.855469)"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_1356_9874" transform="scale(0.0078125)" />
        </pattern>
        <image
          id="image0_1356_9874"
          width="128"
          height="128"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const RejectLeaveDialogCancelIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9173 3.41706L3.58398 12.7504M12.9173 12.7504L3.58398 3.41705"
        stroke="#1B1D22"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AcceptLeaveRequestDialogAcceptIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6496 8.08372C14.6496 11.6183 11.7842 14.4837 8.24961 14.4837C4.71499 14.4837 1.84961 11.6183 1.84961 8.08372C1.84961 4.54909 4.71499 1.68372 8.24961 1.68372C9.25374 1.68372 10.2039 1.91496 11.0496 2.3271M13.4496 4.08372L7.84961 9.68372L6.24961 8.08372"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ApplyLeaveIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.86333 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V3.66668C1 3.31305 1.14048 2.97392 1.39052 2.72387C1.64057 2.47382 1.97971 2.33334 2.33333 2.33334H10.3333C10.687 2.33334 11.0261 2.47382 11.2761 2.72387C11.5262 2.97392 11.6667 3.31305 11.6667 3.66668V6.33334"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1V3.66667M3.66667 1V3.66667M1 6.33333H11.6667M8.33333 11C8.33333 11.7072 8.61429 12.3855 9.11438 12.8856C9.61448 13.3857 10.2928 13.6667 11 13.6667C11.7072 13.6667 12.3855 13.3857 12.8856 12.8856C13.3857 12.3855 13.6667 11.7072 13.6667 11C13.6667 10.2928 13.3857 9.61448 12.8856 9.11438C12.3855 8.61429 11.7072 8.33333 11 8.33333C10.2928 8.33333 9.61448 8.61429 9.11438 9.11438C8.61429 9.61448 8.33333 10.2928 8.33333 11Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 9.99734V11L11.6667 11.6667"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PieChartLegendIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.67236" cy="5.96436" r="5" fill={strokeColor} />
    </svg>
  );
};

export const CheckBrokerIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6672 7.99998C14.6672 11.5346 11.8018 14.4 8.26719 14.4C4.73257 14.4 1.86719 11.5346 1.86719 7.99998C1.86719 4.46535 4.73257 1.59998 8.26719 1.59998C9.27131 1.59998 10.2214 1.83122 11.0672 2.24336M13.4672 3.99998L7.86719 9.59998L6.26719 7.99998"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrendUp = () => {
  return (
    <div
      style={{
        display: 'flex',
        padding: '0.1667rem',
        alignItems: 'flex-start',
        gap: '0.4167rem',
        borderRadius: '4.1667rem',
        background: '#ebf4ec',
      }}
    >
      <svg
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.7334 7.63337L4.12273 5.33593L6.17073 7.30516L10.2667 3.3667M10.2667 3.3667H7.19473M10.2667 3.3667V6.32055"
          stroke="#318439"
          strokeWidth="0.666667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const TrendDownIcon = () => {
  return (
    <div
      style={{
        display: 'flex',
        padding: '0.1667rem',
        alignItems: 'flex-start',
        gap: '0.4167rem',
        borderRadius: '4.1667rem',
        background: '#f8e8e8',
      }}
    >
      <svg
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.49707 3.3667L3.8864 5.66413L5.9344 3.6949L10.0304 7.63336M10.0304 7.63336H6.9584M10.0304 7.63336V4.67952"
          stroke="#A91919"
          strokeWidth="0.666667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export const ArrowRightIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77794 4L12.6668 8M12.6668 8L8.77794 12M12.6668 8L3.3335 8"
        stroke="#1B1D22"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UserIcon = ({ strokeColor = '#1B1D22' }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6001 14.0271C1.6001 11.5101 3.70295 9.46961 8.0001 9.46961C12.2972 9.46961 14.4001 11.5101 14.4001 14.0271C14.4001 14.4275 14.1079 14.7521 13.7475 14.7521H2.25265C1.89225 14.7521 1.6001 14.4275 1.6001 14.0271Z"
        stroke={strokeColor}
      />
      <path
        d="M10.4001 4.35215C10.4001 5.67763 9.32558 6.75215 8.0001 6.75215C6.67461 6.75215 5.6001 5.67763 5.6001 4.35215C5.6001 3.02666 6.67461 1.95215 8.0001 1.95215C9.32558 1.95215 10.4001 3.02666 10.4001 4.35215Z"
        stroke={strokeColor}
      />
    </svg>
  );
};
export const CalenderIcon = ({
  width = '18',
  height = '19',
  strokeColor = 'black',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.90625 6.70361H14.7188M4.43304 1.85205V3.11783M13.0312 1.85205V3.11768M13.0312 3.11768H4.59375C3.19578 3.11768 2.0625 4.25095 2.0625 5.64893V14.0865C2.0625 15.4845 3.19578 16.6178 4.59375 16.6178H13.0312C14.4292 16.6178 15.5625 15.4845 15.5625 14.0865L15.5625 5.64893C15.5625 4.25095 14.4292 3.11768 13.0312 3.11768ZM15.5625 11.7662H10.9219M10.9219 11.7662H6.70312M10.9219 11.7662V15.9849M10.9219 11.7662V7.12553M6.70312 11.7662H2.0625M6.70312 11.7662V15.9849M6.70312 11.7662V7.12553"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const WalletIcon = ({
  width = '17',
  height = '16',
  strokeColor = '#1B1D22',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72052 5.02667L1.72365 13.2667C1.72365 14.2092 2.48775 14.9733 3.43031 14.9733H12.817C13.7595 14.9733 14.5236 14.2092 14.5236 13.2667V6.44001C14.5236 5.65453 13.8869 5.01778 13.1014 5.01778H1.73307C1.72742 5.01778 1.72239 5.02135 1.72052 5.02667ZM1.72052 5.02667C1.72104 4.86692 11.3236 1.02667 11.3236 1.02667V4.62667M11.1215 9.8422L11.1103 9.85334"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CalenderTimerIcon = ({
  width = '17',
  height = '16',
  strokeColor = '#1B1D22',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9854 14H3.4554C3.10178 14 2.76264 13.8595 2.51259 13.6095C2.26255 13.3594 2.12207 13.0203 2.12207 12.6667V4.66668C2.12207 4.31305 2.26255 3.97392 2.51259 3.72387C2.76264 3.47382 3.10178 3.33334 3.4554 3.33334H11.4554C11.809 3.33334 12.1482 3.47382 12.3982 3.72387C12.6483 3.97392 12.7887 4.31305 12.7887 4.66668V7.33334"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1221 2V4.66667M4.78874 2V4.66667M2.12207 7.33333H12.7887M9.4554 12C9.4554 12.7072 9.73636 13.3855 10.2365 13.8856C10.7365 14.3857 11.4148 14.6667 12.1221 14.6667C12.8293 14.6667 13.5076 14.3857 14.0077 13.8856C14.5078 13.3855 14.7887 12.7072 14.7887 12C14.7887 11.2928 14.5078 10.6145 14.0077 10.1144C13.5076 9.61429 12.8293 9.33333 12.1221 9.33333C11.4148 9.33333 10.7365 9.61429 10.2365 10.1144C9.73636 10.6145 9.4554 11.2928 9.4554 12Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1221 10.9973V12L12.7887 12.6667"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HeadphoneIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40039 11.3936H4.00039C4.44222 11.3936 4.80039 11.7517 4.80039 12.1936V13.7936C4.80039 14.2354 4.44222 14.5936 4.00039 14.5936H2.40039V8.99355C2.40039 5.90076 4.9076 3.39355 8.00039 3.39355C11.0932 3.39355 13.6004 5.90076 13.6004 8.99355V14.5936H12.0004C11.5586 14.5936 11.2004 14.2354 11.2004 13.7936V12.1936C11.2004 11.7517 11.5586 11.3936 12.0004 11.3936H13.6004"
        stroke={strokeColor}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VisitIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.2218 7.20001L11.9996 9.20001M11.9996 9.20001L10.2218 11.2M11.9996 9.20001H4.79961M4.79961 4.4004H11.4663M14.3996 4.00001V12C14.3996 13.3255 13.3251 14.4 11.9996 14.4H3.99961C2.67413 14.4 1.59961 13.3255 1.59961 12V4.00001C1.59961 2.67452 2.67413 1.60001 3.99961 1.60001H11.9996C13.3251 1.60001 14.3996 2.67452 14.3996 4.00001Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TagIcon = ({ strokeColor = 'white' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.9022 5.10166L10.898 5.10164M13.0146 1.90093L9.14772 1.60348C8.80489 1.57711 8.46765 1.70186 8.22451 1.945L1.9446 8.22491C1.48461 8.68489 1.48461 9.43067 1.9446 9.89066L6.10896 14.055C6.56894 14.515 7.31472 14.515 7.7747 14.055L14.0546 7.7751C14.2978 7.53197 14.4225 7.19473 14.3961 6.85189L14.0987 2.98499C14.0541 2.40574 13.5939 1.94549 13.0146 1.90093Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AllocationIcon = ({
  width = '16',
  height = '17',
  strokeColor = 'white',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1527_7775)">
        <path
          d="M8.96729 9.60944C7.90112 9.60944 6.8589 9.92559 5.97242 10.5179C5.08593 11.1102 4.395 11.9522 3.987 12.9372C3.579 13.9222 3.47224 15.006 3.68024 16.0517C3.88824 17.0974 4.40165 18.0579 5.15554 18.8118C5.90943 19.5657 6.86995 20.0791 7.91563 20.2871C8.96131 20.4951 10.0452 20.3884 11.0302 19.9803C12.0152 19.5723 12.8571 18.8814 13.4494 17.9949C14.0418 17.1084 14.3579 16.0662 14.3579 15.0001C14.3563 13.5709 13.7878 12.2007 12.7772 11.1901C11.7667 10.1795 10.3965 9.61106 8.96729 9.60944ZM8.49854 10.5721V14.6828L4.68508 16.208C4.5068 15.5842 4.46739 14.929 4.56961 14.2884C4.67183 13.6479 4.9132 13.0375 5.27673 12.5002C5.64026 11.9629 6.11712 11.5119 6.67375 11.1788C7.23038 10.8456 7.85326 10.6386 8.49854 10.5721ZM8.96729 19.4532C8.15756 19.4524 7.36336 19.2309 6.67005 18.8126C5.97673 18.3943 5.41051 17.795 5.03223 17.0791L8.91258 15.5269L12.3896 17.8449C11.9725 18.3481 11.4495 18.7531 10.858 19.0311C10.2664 19.3091 9.62088 19.4532 8.96729 19.4532ZM12.9093 17.0647L9.43604 14.7492V10.5721C10.1586 10.6477 10.8517 10.8991 11.4546 11.3044C12.0575 11.7097 12.5519 12.2566 12.8946 12.8972C13.2373 13.5378 13.4178 14.2526 13.4204 14.9791C13.4229 15.7056 13.2474 16.4217 12.9093 17.0647Z"
          fill={strokeColor}
        />
        <path
          d="M16.785 12.9973H16.2677C16.2031 12.9944 16.1412 12.9707 16.0912 12.9298C16.0412 12.8889 16.0056 12.833 15.9898 12.7703C15.863 12.3713 15.7022 11.984 15.509 11.6126C15.4756 11.557 15.4611 11.4922 15.4676 11.4277C15.4741 11.3632 15.5012 11.3025 15.5449 11.2546L15.9129 10.8866C15.9898 10.8097 16.0376 10.7085 16.0481 10.6003C16.0586 10.492 16.0311 10.3835 15.9704 10.2933C15.3607 9.3865 14.5807 8.60668 13.6738 7.99719C13.5836 7.93623 13.4751 7.9086 13.3667 7.91904C13.2584 7.92949 13.1571 7.97735 13.0803 8.05441L12.7129 8.42245C12.665 8.46604 12.6043 8.49309 12.5398 8.4996C12.4753 8.50611 12.4104 8.49174 12.3547 8.45862C11.9834 8.26534 11.596 8.10438 11.1971 7.9775C11.1344 7.96178 11.0784 7.92625 11.0375 7.87619C10.9966 7.82613 10.9729 7.76422 10.97 7.69964V7.18237C10.97 7.07366 10.9322 6.96833 10.8631 6.8844C10.794 6.80048 10.6979 6.74318 10.5912 6.72232C9.51901 6.50992 8.41556 6.50992 7.34337 6.72232C7.23667 6.74318 7.14055 6.80048 7.07145 6.8844C7.00235 6.96833 6.96457 7.07366 6.96457 7.18237V7.69964C6.96165 7.76422 6.93798 7.82613 6.89708 7.87619C6.85617 7.92625 6.80022 7.96178 6.73752 7.9775C6.33862 8.10442 5.95132 8.26523 5.57984 8.45816C5.52433 8.49157 5.4595 8.50615 5.39503 8.49972C5.33056 8.49328 5.2699 8.46618 5.22209 8.42245L4.85428 8.05441C4.77745 7.97734 4.67615 7.92947 4.56783 7.91903C4.45951 7.90858 4.35093 7.93622 4.26079 7.99719C3.35383 8.60668 2.57386 9.3865 1.96419 10.2933C1.90347 10.3835 1.876 10.4921 1.88648 10.6003C1.89696 10.7085 1.94474 10.8097 2.02164 10.8866L2.38968 11.2546C2.43339 11.3025 2.46049 11.3632 2.46696 11.4277C2.47344 11.4922 2.45894 11.557 2.42561 11.6126C2.23241 11.984 2.07153 12.3713 1.94473 12.7703C1.92899 12.833 1.89346 12.8889 1.8434 12.9298C1.79335 12.9707 1.73144 12.9944 1.66687 12.9974H1.1496C1.04085 12.9974 0.935495 13.0352 0.851566 13.1043C0.767636 13.1735 0.710359 13.2696 0.689545 13.3764C0.476609 14.4484 0.476531 15.5517 0.689315 16.6238C0.710096 16.7305 0.767364 16.8267 0.851301 16.8959C0.935237 16.965 1.04062 17.0028 1.14937 17.0028H1.66687C1.73144 17.0057 1.79335 17.0294 1.8434 17.0703C1.89346 17.1112 1.92899 17.1671 1.94473 17.2298C2.07153 17.6288 2.23241 18.0161 2.42561 18.3875C2.45894 18.4431 2.47344 18.508 2.46696 18.5725C2.46049 18.6369 2.43339 18.6976 2.38968 18.7455L2.02164 19.1135C1.94474 19.1904 1.89697 19.2916 1.88648 19.3998C1.876 19.5081 1.90347 19.6166 1.96419 19.7068C2.57378 20.6136 3.35367 21.3934 4.26057 22.0029C4.35071 22.0638 4.45922 22.0914 4.56748 22.0809C4.67574 22.0705 4.77698 22.0227 4.85383 21.9457L5.22164 21.5777C5.26956 21.534 5.33026 21.5069 5.39477 21.5004C5.45928 21.4938 5.52417 21.5083 5.57984 21.5415C5.95123 21.7348 6.33855 21.8957 6.73753 22.0226C6.80023 22.0383 6.85618 22.0739 6.89709 22.1239C6.93799 22.174 6.96166 22.2359 6.96458 22.3005V22.8177C6.96458 22.9265 7.00236 23.0318 7.07146 23.1157C7.14056 23.1996 7.23668 23.2569 7.34338 23.2778C8.41551 23.4908 9.51908 23.4908 10.5912 23.2778C10.6979 23.2569 10.794 23.1996 10.8631 23.1157C10.9322 23.0318 10.97 22.9265 10.97 22.8177V22.3005C10.9729 22.2359 10.9966 22.174 11.0375 22.1239C11.0784 22.0739 11.1344 22.0383 11.1971 22.0226C11.596 21.8957 11.9833 21.7349 12.3547 21.542C12.4103 21.5084 12.4751 21.4938 12.5397 21.5002C12.6042 21.5067 12.6649 21.5338 12.7127 21.5777L13.0808 21.9457C13.1576 22.0227 13.2588 22.0705 13.3671 22.0809C13.4754 22.0914 13.5839 22.0638 13.674 22.0029C14.5809 21.3934 15.3608 20.6136 15.9704 19.7068C16.0311 19.6166 16.0586 19.5081 16.0481 19.3998C16.0376 19.2916 15.9898 19.1904 15.9129 19.1135L15.5449 18.7455C15.5012 18.6976 15.4741 18.6369 15.4676 18.5724C15.4611 18.5079 15.4756 18.4431 15.509 18.3875C15.7022 18.0161 15.863 17.6288 15.9898 17.2298C16.0056 17.1671 16.0411 17.1112 16.0912 17.0703C16.1412 17.0294 16.2031 17.0057 16.2677 17.0028H16.7852C16.894 17.0028 16.9993 16.965 17.0833 16.8958C17.1672 16.8267 17.2245 16.7305 17.2453 16.6237C17.458 15.5517 17.458 14.4483 17.245 13.3764C17.2242 13.2696 17.1669 13.1735 17.083 13.1043C16.9991 13.0352 16.8937 12.9973 16.785 12.9973ZM16.3895 16.0653H16.2677C16.0041 16.0681 15.7482 16.155 15.5375 16.3135C15.3268 16.4719 15.1722 16.6935 15.0963 16.946C14.9857 17.2938 14.8455 17.6315 14.6772 17.9554C14.5518 18.1877 14.504 18.4541 14.5409 18.7155C14.5777 18.977 14.6973 19.2197 14.8821 19.4083L14.9702 19.4962C14.5424 20.0676 14.0351 20.5749 13.4637 21.0027L13.3753 20.9148C13.1868 20.7298 12.944 20.6102 12.6824 20.5733C12.4209 20.5365 12.1544 20.5845 11.9222 20.7102C11.5985 20.8785 11.2609 21.0186 10.9133 21.1291C10.6608 21.205 10.4392 21.3596 10.2808 21.5703C10.1223 21.781 10.0353 22.0368 10.0325 22.3005V22.4222C9.32614 22.5257 8.60846 22.5257 7.90209 22.4222V22.3005C7.89926 22.0369 7.81229 21.781 7.65385 21.5703C7.49542 21.3596 7.27381 21.205 7.02135 21.1291C6.67359 21.0186 6.33603 20.8784 6.01244 20.7098C5.77999 20.5844 5.51355 20.5367 5.25206 20.5736C4.99057 20.6105 4.74773 20.7301 4.55904 20.9148L4.47091 21.0027C3.8995 20.5749 3.39219 20.0676 2.9644 19.4962L3.05253 19.4083C3.2373 19.2197 3.35687 18.977 3.39373 18.7155C3.43059 18.4541 3.38281 18.1877 3.25737 17.9554C3.08908 17.6315 2.94888 17.2938 2.83831 16.946C2.76241 16.6935 2.60782 16.4719 2.39709 16.3135C2.18637 16.155 1.93053 16.0681 1.6669 16.0653H1.5451C1.44134 15.3589 1.44134 14.6412 1.5451 13.9348H1.66686C1.93049 13.932 2.18633 13.8451 2.39705 13.6866C2.60778 13.5282 2.76237 13.3066 2.83827 13.0541C2.94884 12.7063 3.08905 12.3686 3.25735 12.0447C3.38279 11.8124 3.43057 11.546 3.39371 11.2846C3.35685 11.0232 3.23729 10.7804 3.05251 10.5918L2.96438 10.5039C3.39214 9.93238 3.89954 9.42506 4.47113 8.99741L4.55925 9.0853C4.74771 9.27039 4.99057 9.39015 5.25213 9.42698C5.5137 9.46381 5.78019 9.41577 6.01243 9.28992C6.33612 9.12167 6.67366 8.98153 7.02134 8.87106C7.2738 8.79513 7.49541 8.64053 7.65384 8.42981C7.81227 8.2191 7.89924 7.96327 7.90207 7.69965V7.57787C8.60845 7.47441 9.32613 7.47441 10.0325 7.57787V7.69963C10.0353 7.96325 10.1223 8.21908 10.2807 8.4298C10.4392 8.64052 10.6608 8.79511 10.9132 8.87104C11.261 8.98147 11.5986 9.12177 11.9222 9.29036C12.1546 9.41568 12.4211 9.46337 12.6826 9.42647C12.9442 9.38958 13.187 9.27003 13.3758 9.08528L13.4634 8.99739C14.035 9.42505 14.5424 9.93236 14.9702 10.5039L14.882 10.5918C14.6973 10.7804 14.5777 11.0231 14.5408 11.2846C14.504 11.546 14.5518 11.8124 14.6772 12.0447C14.8455 12.3686 14.9857 12.7063 15.0963 13.0541C15.1722 13.3066 15.3268 13.5282 15.5375 13.6866C15.7482 13.8451 16.0041 13.932 16.2677 13.9348H16.3895C16.4932 14.6412 16.4932 15.3589 16.3895 16.0653Z"
          fill={strokeColor}
        />
        <path
          d="M26.7798 12.1876C26.2235 12.1876 25.6798 12.3525 25.2172 12.6616C24.7547 12.9706 24.3942 13.4098 24.1814 13.9238C23.9685 14.4377 23.9128 15.0032 24.0213 15.5488C24.1298 16.0943 24.3977 16.5955 24.791 16.9888C25.1844 17.3821 25.6855 17.65 26.2311 17.7585C26.7767 17.867 27.3422 17.8113 27.8561 17.5985C28.37 17.3856 28.8093 17.0251 29.1183 16.5626C29.4273 16.1001 29.5923 15.5563 29.5923 15.0001C29.5915 14.2544 29.2949 13.5395 28.7676 13.0122C28.2404 12.485 27.5255 12.1884 26.7798 12.1876ZM26.7798 16.8751C26.4089 16.8751 26.0464 16.7651 25.7381 16.5591C25.4297 16.353 25.1894 16.0602 25.0475 15.7176C24.9056 15.375 24.8685 14.998 24.9408 14.6343C25.0132 14.2706 25.1917 13.9365 25.454 13.6742C25.7162 13.412 26.0503 13.2334 26.414 13.1611C26.7777 13.0887 27.1547 13.1259 27.4973 13.2678C27.8399 13.4097 28.1328 13.65 28.3388 13.9584C28.5448 14.2667 28.6548 14.6292 28.6548 15.0001C28.6543 15.4972 28.4565 15.9738 28.105 16.3253C27.7535 16.6768 27.2769 16.8745 26.7798 16.8751Z"
          fill={strokeColor}
        />
        <path
          d="M28.6548 24.8438H24.9048C24.8432 24.8438 24.7823 24.8559 24.7254 24.8795C24.6685 24.903 24.6168 24.9375 24.5733 24.9811C24.5298 25.0246 24.4952 25.0763 24.4717 25.1332C24.4481 25.19 24.436 25.251 24.436 25.3126V29.0626C24.436 29.1241 24.4481 29.1851 24.4717 29.242C24.4952 29.2988 24.5298 29.3505 24.5733 29.3941C24.6168 29.4376 24.6685 29.4721 24.7254 29.4957C24.7823 29.5192 24.8432 29.5313 24.9048 29.5313H28.6548C28.7163 29.5313 28.7773 29.5192 28.8342 29.4957C28.8911 29.4721 28.9427 29.4376 28.9863 29.3941C29.0298 29.3505 29.0643 29.2988 29.0879 29.242C29.1114 29.1851 29.1236 29.1241 29.1235 29.0626V25.3126C29.1236 25.251 29.1114 25.19 29.0879 25.1332C29.0643 25.0763 29.0298 25.0246 28.9863 24.9811C28.9427 24.9375 28.8911 24.903 28.8342 24.8795C28.7773 24.8559 28.7163 24.8438 28.6548 24.8438ZM28.186 28.5938H25.3735V25.7813H28.186V28.5938Z"
          fill={strokeColor}
        />
        <path
          d="M24.436 5.62506H29.1235C29.2051 5.62504 29.2853 5.60372 29.3562 5.56321C29.427 5.52269 29.486 5.46438 29.5274 5.39405C29.5688 5.32371 29.5911 5.24379 29.5921 5.1622C29.5931 5.0806 29.5728 5.00015 29.5332 4.9288L27.1895 0.710053C27.1453 0.641588 27.0846 0.585293 27.013 0.546312C26.9415 0.507332 26.8613 0.486908 26.7798 0.486908C26.6983 0.486908 26.6181 0.507332 26.5465 0.546312C26.475 0.585293 26.4143 0.641588 26.3701 0.710053L24.0263 4.9288C23.9867 5.00015 23.9664 5.0806 23.9674 5.1622C23.9685 5.24379 23.9908 5.32371 24.0322 5.39405C24.0735 5.46438 24.1326 5.52269 24.2034 5.56321C24.2742 5.60372 24.3544 5.62504 24.436 5.62506ZM26.7798 1.90298L28.3268 4.68756H25.2328L26.7798 1.90298Z"
          fill={strokeColor}
        />
        <path
          d="M20.2173 3.28131V14.5313H17.8735V15.4688H20.2173V27.1876C20.2173 27.2491 20.2294 27.3101 20.2529 27.367C20.2765 27.4238 20.311 27.4755 20.3545 27.5191C20.3981 27.5626 20.4498 27.5971 20.5066 27.6207C20.5635 27.6442 20.6245 27.6563 20.686 27.6563H23.4985V26.7188H21.1548V15.4688H23.4985V14.5313H21.1548V3.75006H23.4985V2.81256H20.686C20.6245 2.81255 20.5635 2.82466 20.5066 2.84821C20.4498 2.87176 20.3981 2.90629 20.3545 2.94982C20.311 2.99335 20.2765 3.04503 20.2529 3.10191C20.2294 3.15879 20.2173 3.21975 20.2173 3.28131Z"
          fill={strokeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1527_7775">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.0610352 6.10352e-05)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.3999 10.5588L2.3999 13.0293C2.3999 13.4038 2.5474 13.7629 2.80995 14.0276C3.0725 14.2924 3.4286 14.4411 3.7999 14.4411H12.1999C12.5712 14.4411 12.9273 14.2924 13.1898 14.0276C13.4524 13.7629 13.5999 13.4038 13.5999 13.0293V10.5588M8.00068 2.3833V10.3833M8.00068 10.3833L11.2007 7.32653M8.00068 10.3833L4.80068 7.32653"
        stroke="#1047DC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IncentivesIcon = ({ strokeColor = '#C8A864' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.79961 2.65131C7.60211 1.99431 8.6281 1.6001 9.74615 1.6001C12.3168 1.6001 14.4007 3.68401 14.4007 6.25464C14.4007 7.37219 14.0068 8.39776 13.3504 9.2001M10.9087 9.74555C10.9087 12.3162 8.82479 14.4001 6.25415 14.4001C3.68352 14.4001 1.59961 12.3162 1.59961 9.74555C1.59961 7.17492 3.68352 5.09101 6.25415 5.09101C8.82479 5.09101 10.9087 7.17492 10.9087 9.74555Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FilePlusIcon = ({ strokeColor = '#1047DC' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.93721 14.4001H3.7372C2.85354 14.4001 2.1372 13.6837 2.13721 12.8001L2.13727 3.20009C2.13727 2.31644 2.85362 1.6001 3.73727 1.6001H10.9374C11.8211 1.6001 12.5374 2.31644 12.5374 3.2001V7.6001M11.6 14.1256V11.8628M11.6 11.8628V9.6001M11.6 11.8628L9.33722 11.8628M11.6 11.8628L13.8627 11.8628M4.93746 4.8001H9.73746M4.93746 7.2001H9.73746M4.93746 9.6001H7.33746"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FileUpIcon = ({ strokeColor = '#1047DC' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.93721 14.4001H3.7372C2.85354 14.4001 2.1372 13.6837 2.13721 12.8001L2.13727 3.20009C2.13727 2.31644 2.85362 1.6001 3.73727 1.6001H10.9374C11.8211 1.6001 12.5374 2.31644 12.5374 3.2001V7.6001M11.6 14.1256V11.8628M11.6 11.8628V9.6001M11.6 11.8628L9.33722 11.8628M11.6 11.8628L13.8627 11.8628M4.93746 4.8001H9.73746M4.93746 7.2001H9.73746M4.93746 9.6001H7.33746"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
